const productEntryFragment = `
	fragment productEntryFragment on ProductInterface {
		id
		title
		uri
		url
		variants {
			... on VariantInterface {
				id
				price
			}
			... on furniture_Variant {
				imageJpg1x: image {
					id
					url @transform(width: 120, height: 120, mode: "fit", format: "jpg", immediately: true)
				}
				imageWebp1x: image {
					id
					url @transform(width: 120, height: 120, mode: "fit", format: "webp", immediately: true)
				}
			}
			... on packages_Variant {
				imageJpg1x: image {
					id
					url @transform(width: 120, height: 120, mode: "fit", format: "jpg", immediately: true)
				}
				imageWebp1x: image {
					id
					url @transform(width: 120, height: 120, mode: "fit", format: "webp", immediately: true)
				}
			}
		}
	}
`;

const productVariantFragment = `
	fragment productVariantFragment on VariantInterface {
		id
		title
		price
		sku
		uri
		... on furniture_Variant {
			imageJpg1x: image {
				id
				url @transform(width: 120, height: 120, mode: "fit", format: "jpg", immediately: true)
			}
			imageWebp1x: image {
				id
				url @transform(width: 120, height: 120, mode: "fit", format: "webp", immediately: true)
			}
		}
		... on packages_Variant {
			imageJpg1x: image {
				id
				url @transform(width: 120, height: 120, mode: "fit", format: "jpg", immediately: true)
			}
			imageWebp1x: image {
				id
				url @transform(width: 120, height: 120, mode: "fit", format: "webp", immediately: true)
			}
		}
	}
`;

const productEntries =
	`
	query ($limit: Int, $term: String) {
		products(
			limit: $limit
			search: $term
			orderBy: "title ASC"
		) {
			...productEntryFragment
		}
	}
` + productEntryFragment;

const productVariants =
	`
	query ($limit: Int, $id: [QueryArgument]) {
		variants(
			limit: $limit
			id: $id
		) {
			...productVariantFragment
		}
	}
` + productVariantFragment;

export { productEntries, productVariants };
